import { render, staticRenderFns } from "./ShowEventsDialog.vue?vue&type=template&id=436b4489&scoped=true"
import script from "@/views/RosterManagement/ShowEventsDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/RosterManagement/ShowEventsDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/RosterManagement/show-events-dialog.scss?vue&type=style&index=0&id=436b4489&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436b4489",
  null
  
)

export default component.exports